import type {
  DescriptionBlock,
  DescriptionSegment,
} from '../models/compensationPlanTypes';

// Plan descriptions are a Markdown subset: "- " bullets, **bold**, and `code`. Parsed to plain
// data so the template renders text with {{ }} and never as HTML.
const INLINE = /\*\*([^*]+)\*\*|`([^`]+)`/g;

function parseInline(line: string): DescriptionSegment[] {
  const segments: DescriptionSegment[] = [];
  let last = 0;
  Array.from(line.matchAll(INLINE)).forEach((match) => {
    const index = match.index ?? 0;
    if (index > last) {
      segments.push({
        text: line.slice(last, index),
        bold: false,
        code: false,
      });
    }
    segments.push(
      match[1] !== undefined
        ? { text: match[1], bold: true, code: false }
        : { text: match[2], bold: false, code: true },
    );
    last = index + match[0].length;
  });
  if (last < line.length) {
    segments.push({ text: line.slice(last), bold: false, code: false });
  }
  return segments;
}

export function parsePlanDescription(
  description: string | null | undefined,
): DescriptionBlock[] {
  return (description ?? '')
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map((line) => ({ segments: parseInline(line.replace(/^[-*]\s+/, '')) }));
}
